import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MediaItem } from '../../../models/media.model';

export interface MediaSelectionChange {
  source: MouseEvent;
  value: MediaItem;
}

@Component({
  selector: 'app-media-file-card',
  imports: [MatIcon, NgClass],
  templateUrl: './media-file-card.component.html',
  styleUrl: './media-file-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'group rounded-lg select-none [.selectable]:not-[.disabled]:cursor-pointer [.disabled]:opacity-50 [.disabled]:cursor-default transition-opacity',
    '[class.selected]': 'selected()',
    '[class.persistent]': 'persistent()',
    '[class.selectable]': 'selectable()',
    '[class.disabled]': 'disabled()',
    '(click)': '_handleClick($event)',
  },
})
export class MediaFileCardComponent {
  public readonly data = input.required<MediaItem>();

  public readonly isImage = computed(() => this.data().type === 'image');

  public readonly loaded = signal(false);

  public readonly disabled = input(false, { transform: booleanAttribute });

  public readonly selectable = input(false, { transform: booleanAttribute });

  public readonly selected = input(false, { transform: booleanAttribute });

  public readonly persistent = input(false, { transform: booleanAttribute });

  public readonly selectionChange = output<MediaSelectionChange>();

  public readonly shareIndicator = input<'own' | 'external' | null>(null);

  public readonly ownerUnitLabel = input<string>('');

  private _handleClick(event: MouseEvent) {
    if (!this.selectable() || this.disabled()) {
      return;
    }

    this.selectionChange.emit({
      source: event,
      value: this.data(),
    });
  }
}
